import { saveTrackingDeviceInfo } from '../../../model/tracking';
import DeviceDetection from '../../../ports-frontend/DeviceDetection';
import DeviceOrientation from '../../../ports-frontend/DeviceOrientation';

export const fetchDeviceInfo = async () => {
  const deviceInfo = await DeviceDetection.getDeviceInfo();
  const currentScreenSize = await DeviceOrientation.getScreenSize();

  saveTrackingDeviceInfo(deviceInfo);
  return {
    deviceInfo,
    currentScreenSize,
  };
};
